<template>
  <FormulateForm v-model="formData" @submit="handleSubmit" name="userForm">
    <FormulateInput
      :readonly="readonly"
      type="text"
      name="name"
      label="Nome"
      validation="required"
      error-behavior="submit"
    />

    <FormulateInput
      :readonly="readonly"
      type="email"
      name="email"
      label="Email"
      validation="required|email"
      error-behavior="submit"
    />

    <FormulateInput
      type="submit"
      :label="submitLabel"
    />

    <a href="#" v-if="this.user && this.user.id" @click="handlePasswordReset">Reset de senha</a>

  </FormulateForm>
</template>

<script>
import * as usersApiClient from '../js/usersApiClient';
import Vue from "vue";

export default {
  name: 'UserForm',
  props: {
    user: Object,
    readonly: Boolean,
  },
  data() {
    return {
      isCreatingUser: ! this.user,
      submitLabel: this.user ? 'Atualizar' : 'Criar',
      formData: this.user,
    }
  },
  watch: {
    user: function(newVal) {
      this.isCreatingUser = ! newVal;
      this.submitLabel = this.isCreatingUser ? 'Criar' : 'Atualizar';
      this.formData = newVal || {};
    }
  },
  methods: {
    async handleSubmit() {
      if (this.isCreatingUser) {
        const createUserResponse = await usersApiClient.createUserAsync(this.formData);

        if (createUserResponse.success) {
          Vue.$toast.success(`Usuário criado com sucesso!`);
          this.$formulate.reset('userForm');
        }
        else {
          Vue.$toast.error(`Erro ao criar usuário com email ${this.formData.email}.\n`+
            `Motivo: ${createUserResponse.errors[0]?.description}`);
        }
        
        this.$emit('userEvent', 'created');
      }
      else {
        const updateUserResponse = await usersApiClient.updateUserAsync(this.user.id, this.formData);

        if (updateUserResponse.success) {
          Vue.$toast.success(`Usuário atualizado com sucesso!`);
          this.$emit('userEvent', 'updated');
        }
        else {
          Vue.$toast.error(`Erro ao atualizar usuário com email ${this.formData.email}.\n`+
            `Motivo: ${updateUserResponse.errors[0]?.description}`);
        }

        const updatedUser = updateUserResponse.data;
        
        if (this.$store.state.user.id === updatedUser.id) {
          await this.$store.dispatch('updateUserData', updatedUser.id);
        }
      }
    },
    async handlePasswordReset() {
      if (this.user && this.user.id) {
        const result = await usersApiClient.requestPasswordResetByUserIdAsync(this.user.id);

        if (result.success) {
          Vue.$toast.success(`Email com reset de senha enviado para o email cadastrado para o usuário \n"${this.user.name}"`);
        }
        else {
          Vue.$toast.error(`Erro ao enviar email de reset de senha para o usuário \n"${this.user.name}"\n`+
            `Motivo: ${result.message}`);
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
